import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import styles from './ButtonPill.module.scss';

interface SubmitPillProps {
  as?: React.ElementType;
  loading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  primary?: boolean;
  secondary?: boolean;
  plain?: boolean;
  type?: string;
  className?: string;
  [key: string]: any;
}

const preventDefaults = (e: React.MouseEvent<HTMLElement>) => {
  e.preventDefault();
};

function SubmitPill({
  as: Component = 'button',
  loading,
  disabled,
  children,
  onClick,
  ...props
}: SubmitPillProps) {
  return (
    <div className={styles.PillLink}>
      <Component
        className={styles.ButtonBlueWide}
        onClick={disabled || loading ? preventDefaults : onClick}
        type="button"
        {...props}
      >
        {children}
        {loading && (
          <Dimmer active>
            <Loader active size="small" />
          </Dimmer>
        )}
      </Component>
    </div>
  );
}

export default SubmitPill;
